<template>
    <div>

        <img src="../content/images/icon-invite1.png" class="invite1-img" v-bd-track-event="['首页', '点击邀请好友']" @click="handleInvite()" v-show="intive"/>
        <div class="dib-wrap user">
            <div class="dot error-bg" v-show="!gloablMsg"></div>
            <div :class="isVip==='vip-month'?'icon-month':'icon-year'" v-if="isVip!=='no-vip'">
                <img :src="isVip==='vip-month'?'../content/images/member/member-vip-icon.png':'../content/images/member/member-svip-icon.png'"/>
                <img v-bd-track-event="['首页', '点击头像进入公司动态（已登录）']" class="lineBlock" :src="getUserIcon(user.icon) || defaultIcon" :title="user.name" :alt="user.name" @click="baseInfo()">
            </div>
            <div class="icon-no-vip" v-else> <img v-bd-track-event="['首页', '点击头像进入公司动态（已登录）']" class="lineBlock" :src="getUserIcon(user.icon) || defaultIcon" :title="user.name" :alt="user.name" @click="baseInfo()" ></div>
            <p v-bd-track-event="['首页', '（未登录状态）点击导航栏的登录']" v-if="!user._id" class="lineBlock text" @click="setLoginStepLogin()">登录</p>

            <el-dropdown v-if="user._id" @command="handleCommand" class="setting-icon" trigger="click" @visible-change="handleChange">
            <span class="el-dropdown-link" v-bd-track-event="['首页', '点击右上角设置按钮（已登录）']">
                <i class="x-icon icon-setting"></i>
            </span>

                <el-dropdown-menu slot="dropdown" class="user-dropdown"  >
                    <el-dropdown-item command="user-basic" v-bd-track-event="['首页', '通过设置点击修改资料（已登录）']"><img src="../content/images/icon-user.png"/>个人中心</el-dropdown-item>
                    <el-dropdown-item command="myWelfare" v-bd-track-event="['首页', '点击我的礼包']"><img src="../content/images/icon-gift.png"/>我的礼包</el-dropdown-item>
                    <el-dropdown-item command="welfareFriends" v-bd-track-event="['首页', '点击邀请好友']"><img src="../content/images/icon-invite.png"/>邀请好友</el-dropdown-item>
                    <el-dropdown-item command="user-order" v-bd-track-event="['首页', '点击我的订单中心']"><img src="../content/images/icon-order.png"/>我的订单</el-dropdown-item>
                    <el-dropdown-item command="feedback" divided v-bd-track-event="['首页', '通过设置点击在线反馈（已登录）']"><img src="../content/images/icon-feedback.png"/>在线反馈</el-dropdown-item>
                    <!--<el-dropdown-item command="check-setting" v-show="false" divided>检测项设置</el-dropdown-item>-->
                    <el-dropdown-item command="faq" v-bd-track-event="['首页', '点击右下角的帮助中心']"> <img src="../content/images/icon-help.png"/>帮助中心</el-dropdown-item>
                    <el-dropdown-item command="logout" v-bd-track-event="['首页', '通过设置点击退出登录（已登录）']" :disabled="progressData.progress > 0 && progressData.progress < 100" divided><img src="../content/images/icon-logout.png"/>退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>

</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
export default {
    data() {
        return {
            intive:false
        }
    },
    computed: {
        ...mapState(['user','defaultIcon']),
        ...mapState('check', ['progressData']),
        ...mapState('welfare', ['gloablMsg']),
        ...mapGetters('qiniu', ['getUserIcon']),
        ...mapGetters(['isVip']),
    },
    created () {
    },
    methods: {
        ...mapMutations(['setLoginStepLogin', 'setFeedback']),
        ...mapMutations('company', ['clearCompany']),
        ...mapMutations('group', ['clearGroup']),
        ...mapMutations('message', ['resetMessage']),
        ...mapActions(['logoutUser', 'isUserCheck', 'cancelCheck']),
        handleChange (val){
            this.intive=val
        },
        handleInvite () {
          this.$router.push({name:"welfareFriends"})
        },
        baseInfo() {
            if (this.user.phone) {
                this.$router.push({name: 'dynamic'});
            }
        },
        handleCommand(command) {
            switch (command) {
                case 'feedback':
                    this.setFeedback(true);
                    break;
                case 'logout':
                    this.isUserCheck().then(checkLength => {
                        if (checkLength) {
                            this.logoutCheckFun(checkLength);
                        } else {
                            this.beforeLogout();
                        }
                    });
                    break;

                default:
                    if (/(http:\/\/)/i.test(command)) {
                        window.open(command);
                    } else {
                        this.$router.push({ name: command });
                    }
                    break;
            }
        },
        logoutCheckFun (checkLength) {
            const h = this.$createElement;
            this.$msgbox({
                title: '提示',
                customClass: 'sys-hint',
                message: h('p', null, [
                    h('span', null, '您当前有'),
                    h('span', {'class': 'error'}, checkLength),
                    h('span', null, '个网站正在诊断，确定终止并退出?')
                ]),
                showCancelButton: true,
                confirmButtonText: '退出',
                cancelButtonText: '取消'
            }).then(action => {
                if (action === 'confirm') {
                    this.cancelCheck();
                    this.logout();
                }
            }, () => {});
        },
        beforeLogout () {
            this.$confirm('系统将退出登录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.logout();
            }, () => {});
        },
        logout () {
            this.logoutUser();
            this.clearCompany();
            this.clearGroup();
            this.resetMessage();
            this.$router.push({ name: 'index' });
        }
    }
}
</script>

<style lang="scss" scoped>
    .invite1-img{
        width: 7.5rem !important;
        height: auto !important;
        position: fixed;
        top:160px;
        right: 120px;
        z-index: 300;
        cursor: pointer;
    }
.user {
    $height: 2.3rem;
    position: absolute;
    top: 50%;
    right: 2rem;
    width: 5.5rem;
    height: $height;
    margin-top: -($height/2);
    border-radius: $height/2;
    background: rgba(228, 229, 240, .08);
    z-index: 1000;
    .icon-year{
        display: inline-block;
        margin-left: 0.8rem;
        margin-right: 0.2rem;
        position: relative;
        img{
            &:nth-child(1){
                width: 1.15rem;
                height: 0.65rem;
                position: absolute;
                top:0;left: 0.1rem;

            }
            &:nth-child(2){
                border-radius: 50%;
                margin-top: 0.45rem;
            }
        }
    }
    .icon-month{
        display: inline-block;
        margin-left: 0.8rem;
        margin-right: 0.2rem;
        position: relative;
        img{
            &:nth-child(1){
                width: 1.15rem;
                height: 0.65rem;
                position: absolute;
                top:0;left: 0.1rem;

            }
            &:nth-child(2){
                border-radius: 50%;
                margin-top: 0.35rem;
            }
        }
    }
    .icon-no-vip{

        display: inline-block;
        margin-left: 0.8rem;
        margin-right: 0.2rem;
        img{
            margin-top: 0.2rem;
            border-radius: 50%;
        }
    }
    .dot {
        position: absolute;
        top: 0;
        left: $height - .8rem;
        width: .75rem;
        height: .75rem;
        border-radius: 50%;
    }
    img {
        vertical-align: middle;
        width: 1.5rem;
        height: 1.5rem;
        box-sizing: border-box;
        cursor: pointer;
    }
    .text {
        font-size: .7rem;
        margin: .6rem 0 .6rem .3rem;
    }
    .setting-icon {
        margin-left: .4rem;
        margin-top: 0.3rem;
        .xw-icon-usersetting {
            width: 1.5rem;
            height: 1.5rem;
            background-position: -14.9rem 0px;
            background-size: auto 7rem;

        }
        .icon-setting {
            font-size: 1.5rem;
            color: rgba(190,190,190,.5);
        }
    }
    .text,
    .setting-icon {
        color: #fff;
        vertical-align: middle;
        cursor: pointer;
    }
}
</style>
<style lang="scss">
.user-dropdown {
    left: auto !important;
    top: 65px !important;
    right: 0;
    width: 10.7rem;
    z-index: 98 !important;
}
.user-dropdown .el-dropdown-menu__item {
    text-align: center;
    line-height: 40px;
    img{
        width: 18px;
        vertical-align: middle;
        margin-right: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// app/components/User.vue